import WaveSurfer from "wavesurfer.js";
import RecordPlugin from "wavesurfer.js/dist/plugins/record.esm.js";
import { saveUploadData, triggerTranscodeJob } from "../apiFunction.js";
import { createMultipartSession, pickMimeType } from "../services/s3MultipartUpload.js";
import toast from "@/mixins/toast";
import Loader from "../components/fixedcomponents/Loader.vue";


export default {
	name: "CommuTestMixin",
	data() {
		return {
			notSubWarning: false,
			showCommunicationPage: false,
			communicationQues: null,
			wavesurfer: null,
			record: null,
			mediaRecorder: null,
			isRecording: false,
			isPlaying: false,
			audioBlob: null,
			mediaStream: null, // MediaStream from camera
			videoBlob: null, // Recorded video blob
			videoURL: null, // Playback URL for recorded video
			isVideoRecording: false, // True while recording video
			isVideoPlaying: false,
			timer: null,
			elapsedMs: 0,
			finalRecordedMs: 0,
			submittedUrl: null,
			recordStartTimestamp: null,
			videoBucketPath: null,
			videoSession: null,         // s3MultipartUpload session for communication video
			finishUploadCalled: false,
			videoLoading: false,
			submittingTest: false,
			permissionsDenied: false,
			videoSubFail: false,
			totalDurationSec: 0
		}
	},
	mixins: [toast],
	components: {Loader},
	computed: {
		formattedTime() {
			const totalSec = Math.floor(this.elapsedMs / 1000);
			const m = String(Math.floor(totalSec / 60)).padStart(2, "0");
			const s = String(totalSec % 60).padStart(2, "0");
			return `${m}:${s}`;
		},
		recordingType() {
			let type = null;
			if (!this.isRecording && !this.audioBlob) type = "answered";
			else if (!this.audioBlob && !this.isRecording) type = "not-rec";
			return type;
		},
		audioAnswered() {
			return this.communicationQues?.answerStatus?.attempted;
		},
		showSubmitAudio() {
			return this.audioBlob && !this.isRecording && !this.submittingTest;
		},
		showPlayPause() {
			return !this.isRecording && this.audioBlob
		},
		showDuration() {
			return this.isRecording || this.isPlaying || this.audioBlob
		}
	},
	beforeDestroy() {
		if (this.wavesurfer) this.wavesurfer.destroy();
		this.stopTimer();
	},
	created() {
		if (localStorage.getItem("commuQues")) {
			this.communicationQues = JSON.parse(localStorage.getItem("commuQues"));
			this.showCommunicationPage = true;
		}
	},
	watch: {
		showCommunicationPage(val) {
			if (val) {
				this.$nextTick(() => {
					// if (this.audioAnswered) {
					// 	this.submittedUrl = this.communicationQues.audioLink;
					// 	this.videoURL = this.communicationQues.videoLink;
					// 	this.elapsedMs = this.communicationQues.answer.audioDurationInSec * 1000;
					// 	this.askCameraPermission();
					// 	this.initWaveSurferForS3();
					// } else {
						this.askCameraPermission();
						this.initWaveSurfer();
					// }
				});
			}
		},
	},
	methods: {
		videoUploadEror(){
			alert("Something went wrong! Please try recording again.");
			this.isRecording = false;
			this.finishUploadCalled = false;
			this.videoSubFail = true;
		},
		async uploadAudio(){
			this.submittingTest = true;
			try {
				const formData = new FormData();
				let audio = await this.blobToWavFile(this.audioBlob);
				let bucketPath = `${this.licenseKey}/${this.testDetails.groupID}/${this.testDetails.testID}/${this.userID}/${this.testDetails.attemptNo}/${this.selectedSection.sectionID}/${this.communicationQues.questionKey}`
				formData.append("file", audio);
				formData.append("bucket", "cvquestionmedia");
				formData.append("path", bucketPath);
				const res = await saveUploadData(formData);
				if(res.status == 200){
					this.submitCommuQues(res.data.data.filePath)
				}
				else {
					alert('Something went wrong!');
					this.submittingTest = false;
				}
			} catch (error) {
				console.error(error)
				alert('Something went wrong!');
				this.submittingTest = false;
			}
		},
		handleWaveSurferSeek(progress) {
			this.elapsedMs = progress * this.wavesurfer.getDuration() * 1000;
			
			// Resync timer start in playback mode
			if (this.isPlaying) {
			this.stopTimer();
			const startReference = Date.now() - this.elapsedMs;
			this.timer = setInterval(() => {
				this.elapsedMs = Date.now() - startReference;
			}, 200);
			}
			const video = this.$refs.camera;
			video.currentTime = this.elapsedMs / 1000; // seek to 10 seconds
			
		},
		checkAndGoBack() {
			if ((this.audioBlob) || this.isRecording) {
				this.notSubWarning = true;
			} else this.handleBack()
		},

		async showCommunication(data) {
			this.communicationQues = data;
			this.resetRecordingVars();
			// if (data.answer && data.answer.audioPath) {
			// 	let link = await this.getS3Link(data.answer.audioPath, "audio");
			// 	let videolink = await this.getS3Link(data.answer.videoPath, "video");
			// 	this.communicationQues.audioLink = link;
			// 	this.communicationQues.videoLink = videolink;
			// 	this.videoURL = videolink;
			// 	this.elapsedMs = this.totalDurationSec = this.communicationQues.answer.audioDurationInSec * 1000;
			// }
			localStorage.setItem("commuQues", JSON.stringify(this.communicationQues));
			this.showCommunicationPage = true;
			// this.Loaderstatus = true;
			// setTimeout(() => {
			// 	this.Loaderstatus = false;
			// }, 4000);
		},
		// async loadS3Audio(url) {
		// 	try {
		// 		const res = await fetch(url, {
		// 			mode: "cors"
		// 		});
		// 		if (!res.ok) throw new Error(`HTTP ${res.status}`);
		// 		const blob = await res.blob();
		// 		const objectUrl = URL.createObjectURL(blob);
		// 		return objectUrl;
		// 	} catch (e) {
		// 		console.error("Error loading S3 audio:", e);
		// 	}
		// },

		// async initWaveSurferForS3() {
		// 	let blobData = await this.loadS3Audio(this.communicationQues.audioLink);
		// 	if (this.wavesurfer) {
		// 		this.wavesurfer.destroy();
		// 	}
		// 	this.wavesurfer = WaveSurfer.create({
		// 		container: this.$refs.waveform,
		// 		waveColor: "#bfcde0",
		// 		progressColor: "#1a5fad",
		// 		cursorWidth: 0,
		// 		cursorColor: "#333",
		// 		barWidth: 2,
		// 		height: 60,
		// 		barGap: 4, // spacing between bars
		// 		barRadius: 4,
		// 		responsive: true,
		// 	});
		// 	this.wavesurfer.load(blobData);
		// 	this.wavesurfer.on('interaction', () => {
		// 		const progress = this.wavesurfer.getCurrentTime() / this.wavesurfer.getDuration();
		// 		this.handleWaveSurferSeek(progress);	
		// 	});
		// 	this.wavesurfer.on("play", () => (this.isPlaying = true));
		// 	this.wavesurfer.on("pause", () => (this.isPlaying = false));
		// 	this.wavesurfer.on(
		// 		"finish",
		// 		() => {(this.isPlaying = false),
		// 		this.wavesurfer.seekTo(0);
		// 		this.elapsedMs = this.recordingType == 'answered' ? this.communicationQues.answer.audioDurationInSec * 1000 : this.finalRecordedMs;
		// });
		// },
		// async getS3Link(link, type) {
		// 	try {
		// 		const res = await getS3Link({
		// 			path: link,
		// 			type: type
		// 		});
		// 		if (res.status == 200) {
		// 			const linkVar = res.data.data.url;
		// 			return linkVar;
		// 		} else return null;
		// 	} catch (error) {
		// 		console.error(error);
		// 		return null;
		// 	}
		// },
		async submitCommuQues(audioPath) {
			let answerStats = JSON.parse(JSON.stringify(this.communicationQues.answerStatus));
			answerStats.attempted = true;
			answerStats.unattempted = false;
			const newPath = this.videoBucketPath.replace(
				/(_communication)\d*\.webm$/,
				"$1.mp4"
			);
			let payload = {
				topicID : this.testDetails.topicID,
				testID : this.testDetails.testID,
				groupID : this.testDetails.groupID,
				sectionID: this.selectedSection.sectionID,
				questionKey: this.communicationQues.questionKey,
				answer: {
					audioPath: audioPath,
					videoPath: newPath,
					audioDurationInSec: Math.round(this.totalDurationSec)
				},
				answerStatus: answerStats,
				attemptNo: this.testDetails.attemptNo,
				answerAudioPath: audioPath,
				answerVideo: newPath,
				audioDurationInSec: Math.round(this.totalDurationSec)
			}
			if (this.sectionId)
				this.$store.commit("testVUEX/updateSectionDetails", payload);
			
			this.handleBack();
			this.submittingTest = false;

			this.$store
				.dispatch("testVUEX/saveAnswer", payload)
				.then(() => {
					let payload1 = {
						topicID: this.testDetails.topicID,
						testID: this.testDetails.testID,
						groupID: this.testDetails.groupID,
						userID: this.userID,
						attemptNo: this.testDetails.attemptNo,
						sectionId: this.sectionIDVal
					};
					this.$store.dispatch("testVUEX/getTestResponse", payload1);
				})
				.catch((error) => {
					console.error("Save failed", error);
				});
		},
		async blobToWavFile(audioBlob) {
			const wavBlob = await this.blobToWav(audioBlob);
			return new File([wavBlob], "recording.wav", {
				type: "audio/wav"
			});
		},
		encodeWAV(audioBuffer) {
			const numOfChan = audioBuffer.numberOfChannels;
			const length = audioBuffer.length * numOfChan * 2 + 44;
			const buffer = new ArrayBuffer(length);
			const view = new DataView(buffer);
			const sampleRate = audioBuffer.sampleRate;

			let offset = 0;

			// WAV header
			function writeString(str) {
				for (let i = 0; i < str.length; i++) {
					view.setUint8(offset++, str.charCodeAt(i));
				}
			}
			writeString("RIFF");
			view.setUint32(offset, 36 + audioBuffer.length * numOfChan * 2, true);
			offset += 4;
			writeString("WAVE");
			writeString("fmt ");
			view.setUint32(offset, 16, true);
			offset += 4; // PCM
			view.setUint16(offset, 1, true);
			offset += 2; // Linear quantization
			view.setUint16(offset, numOfChan, true);
			offset += 2;
			view.setUint32(offset, sampleRate, true);
			offset += 4;
			view.setUint32(offset, sampleRate * numOfChan * 2, true);
			offset += 4; // byte rate
			view.setUint16(offset, numOfChan * 2, true);
			offset += 2; // block align
			view.setUint16(offset, 16, true);
			offset += 2; // bits/sample
			writeString("data");
			view.setUint32(offset, audioBuffer.length * numOfChan * 2, true);
			offset += 4;

			// PCM samples
			for (let i = 0; i < audioBuffer.length; i++) {
				for (let channel = 0; channel < numOfChan; channel++) {
					let sample = audioBuffer.getChannelData(channel)[i];
					sample = Math.max(-1, Math.min(1, sample));
					view.setInt16(
						offset,
						sample < 0 ? sample * 0x8000 : sample * 0x7fff,
						true
					);
					offset += 2;
				}
			}

			return new Blob([buffer], {
				type: "audio/wav"
			});
		},
		async decodeBlobToPCM(blob) {
			const arrayBuffer = await blob.arrayBuffer();
			const audioCtx = new(window.AudioContext || window.webkitAudioContext)();
			return await audioCtx.decodeAudioData(arrayBuffer); // returns AudioBuffer
		},
		async blobToWav(audioBlob) {
			const audioBuffer = await this.decodeBlobToPCM(audioBlob); // PCM samples
			return this.encodeWAV(audioBuffer); // WAV Blob!
		},
		loadSectionData() {
			let section = this.sectionId - 1;
			this.$store.commit(
				"testVUEX/saveSelectedSection",
				this.sectionDetails[section]
			);
		},
		async handleBack() {
			this.notSubWarning = false;
			try {
				// 🛑 Stop active audio/video recording if any
				if (this.isRecording && this.record) {
					this.record.stopRecording();
				}
				if (this.mediaRecorder && this.isVideoRecording) {
					this.mediaRecorder.stop();
				}
			} catch (err) {
				console.warn("Error stopping recordings:", err);
			}
			if (this.mediaStream) {
				this.mediaStream.getTracks().forEach((track) => track.stop());
				this.mediaStream = null;
			}

			// 🔴 2️⃣ Reset video display
			// const video = this.$refs.camera;
			// if (video) {
			// 	video.srcObject = null;
			// 	video.src = "";
			// 	video.load();
			// }

			// 🔴 3️⃣ Reset audio (WaveSurfer + recording)
			if (this.record && this.isRecording) {
				this.record.stopRecording();
			}

			this.resetRecordingVars();

			// 👈 Finally, navigate back to previous section/page
			localStorage.removeItem("commuQues");
			this.showCommunicationPage = false;
			this.communicationQues = null;
		},
		resetRecordingVars() {
			this.isRecording = false;
			this.isPlaying = false;
			this.isVideoRecording = false;
			this.isVideoPlaying = false;
			this.videoLoading = false;
			this.finishUploadCalled = false;
			this.audioBlob = null;
			this.videoBlob = null;
			this.videoURL = null;
			this.finalRecordedMs = 0;
			this.elapsedMs = 0;
		},

		async stopVideoRecording() {
			if (this.mediaRecorder && this.isVideoRecording) {
				this.mediaRecorder?.stop();
				
				if (this.mediaStream) {
					this.mediaStream.getTracks().forEach((track) => track.stop());
					this.mediaStream = null;
				}

				this.isLiveCameraActive = false; // update flag
				this.videoLoading = false;
			}
		},
		async startVideoRecording() {
			this.recordStartTimestamp = Date.now();
			if (!this.mediaStream) {
				await this.restoreLiveCamera();
			} else {
				const video = this.$refs.camera;
				if (video.srcObject !== this.mediaStream) {
					video.srcObject = this.mediaStream;
					video.muted = true;
					await video.play();
				}
				await this.record.startRecording({
					audio: true,
					video: false
				});
			}

			// await this.restoreLiveCamera(); // must complete first

			if (!this.mediaStream) {
				return;
			}

			this.videoBlob = null;
			this.videoURL = null;
			this.$forceUpdate();
			this.isVideoRecording = true;
			this.isVideoPlaying = false;

			if (this.mediaRecorder) {
				if (this.mediaRecorder.state !== "inactive") {
					this.mediaRecorder.stop();
				}
				this.mediaRecorder = null;
			}

			this.mediaRecorder = new MediaRecorder(this.mediaStream, {
				mimeType: "video/webm",
			});

			await this.startUploadRecordedVideo();
		},
		async restoreLiveCamera() {
			if (this.mediaStream) {
				this.mediaStream.getTracks().forEach((track) => track.stop());
				this.mediaStream = null;
			}

			try {
				const stream = await navigator.mediaDevices.getUserMedia({
					video: {
						facingMode: "user"
					},
					audio: true,
				});
				const video = this.$refs.camera;
				video.pause();
				video.src = "";
				video.srcObject = null;
				video.load();
				this.mediaStream = stream;
				video.srcObject = stream;
				video.muted = true;

				// Set video size explicitly (optional for debugging)
				video.width = 640;
				video.height = 480;
				setTimeout(async () => {
					const playPromise = video.play();
					if (playPromise !== undefined) {
						playPromise
							.then(() => {
								console.log("[restoreLiveCamera] Video playing.");
							})
							.catch((error) => {
								console.error(
									"[restoreLiveCamera] video.play() rejected:",
									error
								);
							});
					}

					// Make sure to try a delayed play
					setTimeout(() => {
						video
							.play()
							.catch((e) => console.error("Video play error (delayed):", e));
					}, 200);
					video.onerror = () => {
						setTimeout(() => {
							video
								.play()
								.catch((e) => console.error("Video play error (delayed):", e));
						}, 200);
					};

					this.videoLoading = false;
				}, 800);
				await this.record.startRecording({
					audio: true,
					video: false
				});
			} catch (err) {
				console.error("[restoreLiveCamera] Error restoring camera:", err);
			}
		},

		playRecordedVideo() {
			if (!this.videoURL) return;
			const video = this.$refs.camera;
			video.srcObject = null;
			video.src = this.videoURL;
			video.muted = false;
			video.load();
			video.onloadeddata = () => {
				video.currentTime = 0;
				video.play();
				this.isVideoPlaying = true;
			};
			video.onended = () => {
				this.isVideoPlaying = false;
			};
		},
		async startUploadRecordedVideo() {
			this.videoSubFail = false;
			try {
				// 1. Pick MIME type before constructing MediaRecorder (POC pattern)
				const mimeType = pickMimeType();
				const ext      = mimeType.includes("mp4") ? "mp4" : "webm";
				console.log("[commu-video] MIME type:", mimeType);

				// 2. Build S3 paths
				const fileName       = `${this.testDetails.groupID}_${this.testDetails.testID}_${this.userID}_${this.selectedSection.sectionID}_${this.communicationQues.questionKey}_communication.${ext}`;
				const pathPrefix     = `processed_streams/production/${this.testDetails.groupID}/${this.testDetails.testID}/${this.userID}/${this.testDetails.attemptNo}/${this.selectedSection.sectionID}/${this.communicationQues.questionKey}/${this.recordStartTimestamp}/communication/`;
				this.videoBucketPath = `${pathPrefix}${fileName}`;

				// 3. Initiate multipart upload session (independent from camera/screen sessions)
				this.videoSession = createMultipartSession();
				await this.videoSession.initiate(fileName, this.videoBucketPath, pathPrefix, mimeType);

				// 4. Create MediaRecorder — 1-second timeslices, POC pattern
				this.mediaRecorder = new MediaRecorder(this.mediaStream, { mimeType });

				const chunks = [];

				this.mediaRecorder.ondataavailable = (event) => {
					if (!event.data || event.data.size === 0) return;
					chunks.push(event.data);
					this.videoSession.feedBlob(event.data);
				};

				this.mediaRecorder.onerror = (e) =>
					console.error("[commu-video] MediaRecorder error:", e);

				this.mediaRecorder.onstop = async () => {
					// Build local playback URL from accumulated chunks
					this.videoBlob = new Blob(chunks, { type: mimeType });
					this.videoURL  = URL.createObjectURL(this.videoBlob);

					const video = this.$refs.camera;
					if (video) {
						video.srcObject = null;
						video.src       = this.videoURL;
						video.muted     = true;
						video.load();
					}

					// Signal to the UI that the upload is in progress (disables buttons, shows loader)
					this.finishUploadCalled = true;

					// Flush remaining data, complete the S3 session, then trigger
					// the MediaConvert merge job via the post-processing webhook.
					await this.videoSession.flush(
						(result) => {
							this.finishUploadCalled = false;
							console.log("[commu-video] Upload complete:", result);
							// result.key is the timestamped S3 key — use it, not videoBucketPath
							triggerTranscodeJob(result.fileID, {
								convert: { delimiterKey: "communication" },
							}).catch((err) => console.error("[commu-video] triggerTranscodeJob error:", err.message));
						},
						(err) => {
							console.error("[commu-video] Upload failed:", err.message);
							this.videoUploadEror(); // also resets finishUploadCalled
						}
					);
				};

				this.mediaRecorder.start(1000);
				console.log("[commu-video] Recording started");
			} catch (error) {
				console.error("[commu-video] Error starting upload:", error);
				this.videoUploadEror();
			}
		},
		async askCameraPermission() {
			try {
				if (this.mediaStream) {
					this.mediaStream.getTracks().forEach((track) => track.stop());
					this.mediaStream = null;
				}
				this.mediaStream = await navigator.mediaDevices.getUserMedia({
					video: {
						facingMode: "user"
					},
					audio: true,
				});
				const video = this.$refs.camera;
				if (video) {
					video.srcObject = this.mediaStream;
					video.muted = true;
					video.play();
				}
			} catch (err) {
				console.error("Camera error:", err);
				alert("Please enable your camera and microphone to continue!");
				this.permissionsDenied = true;
			}
		},
		async initWaveSurfer() {
			if (this.wavesurfer) {
				this.wavesurfer.destroy();
				this.wavesurfer = null;
			}

			const container = this.$refs.waveform;
			if (!container) {
				console.error("WaveSurfer container not found!");
				return;
			}

			// ✅ Create WaveSurfer instance
			this.wavesurfer = WaveSurfer.create({
				container: this.$refs.waveform,
				waveColor: "black", // light sample color initially
				progressColor: "#1a5fad",
				cursorWidth: 0,
				height: 62,
				responsive: true,
				barWidth: 2,
				barGap: 3, // spacing between bars
				barRadius: 4,
				interact: false
			});

			// ✅ Generate a sample (silent) waveform before recording
			this.loadSampleWave();

			// ✅ Register Record Plugin
			this.record = this.wavesurfer.registerPlugin(RecordPlugin.create());
			this.wavesurfer.on('interaction', () => {
			const progress = this.wavesurfer.getCurrentTime() / this.wavesurfer.getDuration();
			this.handleWaveSurferSeek(progress);	
			});
			// 🎤 When recording starts
			this.record.on("record-start", () => {
				this.fullReset();
				if (this.isPlaying && this.wavesurfer) {
					this.wavesurfer.stop();
				}
				this.isRecording = true;
				this.elapsedMs = 0;
				this.fullReset();
				this.startTimer();

				// Clear existing (sample) wave and show live blue wave
				this.wavesurfer.empty();
				this.wavesurfer.setOptions({
					waveColor: "#1a5fad",
					progressColor: "#1a5fad",
				});
			});

			// 🟡 When recording stops
			this.record.on("record-end", (blob) => {
				this.isRecording = false;
				this.audioBlob = blob;
				this.finalRecordedMs = this.elapsedMs;
				this.stopTimer();

				// Load the recorded audio
				this.wavesurfer.loadBlob(blob);

				// Change to disabled color after waveform fully loads
				this.wavesurfer.once("ready", () => {
					this.wavesurfer.setOptions({
						interact: true,
						waveColor: "#bfcde0",
						progressColor: "#1a5fad",
					});
					this.totalDurationSec = this.wavesurfer.getDuration();
					this.wavesurfer.seekTo(0);
					this.playbackProgress = 0;
				});
			});
		},
		fullReset() {
			if (this.wavesurfer) {
				try {
					this.wavesurfer.stop();
					this.wavesurfer.seekTo(0);
					this.wavesurfer.setOptions({
						waveColor: "#1a5fad",
						progressColor: "#1a5fad",
					});
				} catch (err) {
					console.warn("WaveSurfer reset issue:", err);
				}
			}

			this.isPlaying = false;
			this.playbackProgress = 0;
			this.elapsedMs = 0;
			clearInterval(this.timerInterval);
		},

		// 🟢 Function to load a placeholder wave before recording
		async loadSampleWave() {
			const audioCtx = new(window.AudioContext || window.webkitAudioContext)();
			const sampleRate = 44100;
			const duration = 2; // 2 seconds
			const length = sampleRate * duration;

			const buffer = audioCtx.createBuffer(1, length, sampleRate);
			const data = buffer.getChannelData(0);

			const barCount = 50;
			const samplesPerBar = Math.floor(length / barCount);
			const barHeights = [0.1, 0.2, 0.15, 0.3, 0.05, 0.25];

			for (let bar = 0; bar < barCount; bar++) {
				const height = barHeights[bar % barHeights.length];
				for (let i = 0; i < samplesPerBar; i++) {
					const index = bar * samplesPerBar + i;
					data[index] = height * Math.sin(i / 5) * (0.5 + 0.5 * Math.random());
				}
			}

			const wavBlob = await this.audioBufferToBlob(buffer);
			await this.wavesurfer.loadBlob(wavBlob);
		},

		// 🧩 Helper: Convert AudioBuffer → Blob
		audioBufferToBlob(audioBuffer) {
			return new Promise((resolve) => {
				const numOfChan = audioBuffer.numberOfChannels,
					length = audioBuffer.length * numOfChan * 2 + 44,
					buffer = new ArrayBuffer(length),
					view = new DataView(buffer),
					channels = [],
					sampleRate = audioBuffer.sampleRate;

				let offset = 0;

				// Write WAV header
				const writeString = (str) => {
					for (let i = 0; i < str.length; i++) {
						view.setUint8(offset++, str.charCodeAt(i));
					}
				};

				writeString("RIFF");
				view.setUint32(offset, 36 + audioBuffer.length * numOfChan * 2, true);
				offset += 4;
				writeString("WAVE");
				writeString("fmt ");
				view.setUint32(offset, 16, true);
				offset += 4;
				view.setUint16(offset, 1, true);
				offset += 2;
				view.setUint16(offset, numOfChan, true);
				offset += 2;
				view.setUint32(offset, sampleRate, true);
				offset += 4;
				view.setUint32(offset, sampleRate * 2 * numOfChan, true);
				offset += 4;
				view.setUint16(offset, numOfChan * 2, true);
				offset += 2;
				view.setUint16(offset, 16, true);
				offset += 2;
				writeString("data");
				view.setUint32(offset, audioBuffer.length * numOfChan * 2, true);
				offset += 4;

				// Write PCM samples
				for (let i = 0; i < audioBuffer.numberOfChannels; i++) {
					channels.push(audioBuffer.getChannelData(i));
				}

				let interleaved = new Float32Array(audioBuffer.length * numOfChan);
				for (let i = 0; i < audioBuffer.length; i++) {
					for (let ch = 0; ch < numOfChan; ch++) {
						interleaved[i * numOfChan + ch] = channels[ch][i];
					}
				}

				let pos = 44;
				for (let i = 0; i < interleaved.length; i++, pos += 2) {
					let sample = Math.max(-1, Math.min(1, interleaved[i]));
					view.setInt16(
						pos,
						sample < 0 ? sample * 0x8000 : sample * 0x7fff,
						true
					);
				}

				resolve(new Blob([view], {
					type: "audio/wav"
				}));
			});
		},

		async toggleRecording() {
			if(this.permissionsDenied) {
				alert("Please enable your camera and microphone to continue!");
				return;
			}
			if (!this.record) await this.initWaveSurfer();
			if (this.isRecording) {
				// Stop both
				this.videoLoading = true;
				this.record.stopRecording();
				this.stopVideoRecording(); // <-- Stop video
			} else {
				// Start both
				this.videoLoading = true;
				this.startVideoRecording(); // <-- Start video

			}
		},

		async togglePlay() {
			if (!this.wavesurfer) return;

			const video = this.$refs.camera;

			// 🔹 CASE 1: Currently Playing → Pause both
			if (this.isPlaying) {
				this.wavesurfer.pause();
				if (video && !video.paused) {
					video.pause();
				}
				this.isPlaying = false;
				this.elapsedMs = this.wavesurfer.getCurrentTime() * 1000;
				this.stopTimer();
				return;
			}

			// 🔹 CASE 2: Start Playing (both)
			this.isPlaying = true;
			// this.elapsedMs = 0;
			const currentTime = this.wavesurfer.getCurrentTime();
			if (currentTime >= this.wavesurfer.getDuration() - 0.2) {
				this.wavesurfer.seekTo(0);
				this.elapsedMs = 0; // Reset elapsed time when starting from end
			} else if (currentTime < 0.2) {
				this.elapsedMs = 0; // Reset elapsed time when starting near beginning
			}
			this.startTimer();

			// Reset wave to start if it's at the end
			if (
				this.wavesurfer.getCurrentTime() >=
				this.wavesurfer.getDuration() - 0.2
			) {
				this.wavesurfer.seekTo(0);
			}

			// 🔸 Sync: reset video to first frame
			if (video && this.videoURL) {
				if (video.ended || video.currentTime >= video.duration - 0.2) {
					video.srcObject = null;
					video.src = this.videoURL;
					video.muted = false;
					video.load();

					await new Promise((resolve) => {
						video.onloadeddata = () => {
							video.currentTime = 0;
							resolve();
						};
					});
				}
			}

			// Start both video and audio playback
			this.wavesurfer.play();
			if (video && this.videoURL) {
				video.play();
			}

			// When audio finishes → stop both
			this.wavesurfer.once("finish", () => {
				this.isPlaying = false;
				this.wavesurfer.stop();
				this.stopTimer();
				// this.elapsedMs = this.finalRecordedMs;

				if (video && !video.paused) {
					video.pause();
					video.currentTime = 0;
				}
			});

			// When video ends → stop both (if user skips to end)
			if (video) {
				video.onended = () => {
					this.isPlaying = false;
					this.wavesurfer.stop();
					this.stopTimer();
					this.elapsedMs = this.finalRecordedMs;
				};
			}
		},

		startTimer() {
			this.stopTimer();
			const start = Date.now() - this.elapsedMs;
			this.timer = setInterval(() => {
				if (this.isRecording || this.isPlaying) {
					this.elapsedMs = Date.now() - start;
				}
			}, 200);
		},

		stopTimer() {
			clearInterval(this.timer);
		},
	}
}